import type { ScmProviderId } from '@/types/scm-provider';
import { scmPost } from './scmClient';

export interface ReleaseEnvironmentItem {
  name: string;
  id?: number | string;
  rank?: number;
  hasKatalonHint: boolean;
  hintPathPreview?: string;
}

export interface ReleaseDefinitionEnvironments {
  releaseDefinitionId: number;
  releasePipelineName: string;
  success: boolean;
  message: string;
  environments: ReleaseEnvironmentItem[];
}

export interface ReleaseEnvironmentsResponse {
  success: boolean;
  message: string;
  definitions: ReleaseDefinitionEnvironments[];
}

export async function getReleaseEnvironments(
  provider: ScmProviderId,
  body: {
    organization: string;
    project: string;
    releaseDefinitionIds: number[];
    pipelineNames?: Record<string, string>;
  },
  patToken: string,
): Promise<ReleaseEnvironmentsResponse> {
  return scmPost(
    provider,
    '/api/scm/release-environments',
    patToken,
    body,
  ) as Promise<ReleaseEnvironmentsResponse>;
}
